<div *appNoShellRender>
  <app-homebanners [homeBanners]="homeBanners" *ngIf="city !== 'skopje' && city !== 'beograd'"></app-homebanners>
  <app-homecategories [categories]="categories" *ngIf="city == 'sofia' || city == 'varna' || city == 'plovdiv' || city == 'skopje'|| city == 'beograd'" class="home-section">
  </app-homecategories>
  <app-homerecommended *ngIf="city !== 'skopje' && city !== 'beograd'" [recommendedBanners]="recommendedBanners" class="home-section"></app-homerecommended>
  <app-hometypekitchen class="home-section"></app-hometypekitchen>
  <app-homeselected [selectedForYou]="homeSelectedForYou" class="home-section"></app-homeselected>
  <app-homelastadded  [newlyAdded]="homeLastAdded" class="home-section"></app-homelastadded>
  <app-homeblog [news]="lastNews" class="home-section"></app-homeblog>
  <app-lastactivities *ngIf="city !== 'skopje' && city !== 'beograd'" [lastActions]="lastActions" class="hidden-sm home-section"></app-lastactivities>
  <home-app-ad *ngIf="city !== 'skopje' && city !== 'beograd'"></home-app-ad>
</div>
